import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { asyncReceiveJoke } from '../../store/plain/joke/action';
import { ProfileHeader } from './users/ProfileHeader';

export function PublicYours() {
  const dispatch = useDispatch();
  const { joke = null } = useSelector((state) => state);

  useEffect(() => {
    if (joke === null) dispatch(asyncReceiveJoke());
  }, [dispatch, joke]);
  return (
    <div>
      <ProfileHeader
        ava="https://ui-avatars.com/api/?name=You&size=250"
        name="Your Name"
        email="your@email.com"
        score={999}
      />
      <div className="mt-8 mb-4">
        <div className="grid h-96 place-items-center">
          <div className="text-center">
            Your threads will appear here <br />
            once you&rsquo;re logged in
          </div>
          <div className="text-center">
            {joke && (
              <>
                <dt>{joke.setup}</dt>
                <dd>
                  <em>{joke.punchline}</em>
                </dd>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
